module.exports = kolibriGlobal.utils.i18n;